<template>
   <header class='header nav-custom-after' >
        <div class='header__group col animated slideInLeft delay-2 px-0' :class='{ "header__group--show": showMenu }'>
            <div class="d-flex flex-row align-items-center justify-content-sm-start justify-content-between px-0">            
                <div class="d-flex">
                    <a class="navbar-brand mx-0" :href='`https://${$store.state.meta.lang}.idcgames.com/`' aria-label="idcgames.com"></a>
                </div>
                <div class="d-sm-flex d-none px-4">
                    <router-link class="logo game text-white" :to="`/${$store.state.meta.lang}/landing`">
                        <h5> IDC Gifts </h5> 
                    </router-link>                    
                </div>
            </div>        
            <div class="first_header_group mx-3">
                <b-dropdown
                    :text="$t('gifts_giveaways')"
                    size="sm header_dropdown" 
                >
                    <b-dropdown-item>
                        <router-link :to="`/${$store.state.meta.lang}/landing`">
                            <font-awesome-icon :icon='["fa", "home"]' /> &nbsp; {{ $t('gifts_giveaways') }}
                        </router-link>
                    </b-dropdown-item>
                    
                    <b-dropdown-item v-if="$store.state.username && $store.state.username.length">
                        <router-link :to="`/${$store.state.meta.lang}/giveaway/create-new`">
                            <font-awesome-icon :icon='["fa", "plus-circle"]' /> &nbsp; {{ $t('gifts_create_giveaway') }}
                        </router-link>
                    </b-dropdown-item>

                    <b-dropdown-item>
                        <router-link :to="`/${$store.state.meta.lang}/giveaways/wishlist`">
                            <font-awesome-icon :icon='["fa", "users"]' /> &nbsp; {{ $t('gifts_community_wishlist') }}
                        </router-link>
                    </b-dropdown-item>

                    <b-dropdown-item v-if="$store.state.username && $store.state.username.length">
                        <router-link :to="`/${$store.state.meta.lang}/giveaway/created`">
                            <font-awesome-icon :icon='["fa", "gift"]' /> &nbsp; {{ $t('gifts_view_created') }} 
                        </router-link>
                    </b-dropdown-item>
                    
                    <b-dropdown-item v-if="$store.state.username && $store.state.username.length">
                        <router-link :to="`/${$store.state.meta.lang}/giveaway/entered`">
                            <font-awesome-icon :icon='["fa", "pen"]' /> &nbsp; {{ $t('gifts_view_entered') }}
                        </router-link>
                    </b-dropdown-item>

                    <b-dropdown-item v-if="$store.state.username && $store.state.username.length">
                        <router-link :to="`/${$store.state.meta.lang}/giveaway/won`">
                            <font-awesome-icon :icon='["fa", "trophy"]' /> &nbsp; {{ $t('gifts_view_won') }}                            
                        </router-link>
                    </b-dropdown-item>
                </b-dropdown>
                
                <router-link :to="`/${$store.state.meta.lang}/discussions/deals`">
                    <button class="btn btn-outline-primary my-2 btn-sm"><span style="font-size: 13pt;">{{ $t('gifts_deals') }}</span></button>
                </router-link>

                <router-link :to="`/${$store.state.meta.lang}/discussions`" v-if="!$store.state.username || !$store.state.username.length">
                    <button class="btn btn-outline-primary my-2 btn-sm">
                        <span style="font-size: 13pt;">{{ $t('gifts_discussions') }}</span>
                    </button>
                </router-link>

                <b-dropdown 
                    v-if="$store.state.username && $store.state.username.length"
                    text="Discussion"
                    size="sm header_dropdown" 
                    >
                    <b-dropdown-item>
                        <router-link :to="`/${$store.state.meta.lang}/discussions`">
                            <font-awesome-icon :icon='["fa", "comments"]' /> &nbsp; {{ $t('gifts_discussions') }} 
                        </router-link>
                    </b-dropdown-item>
                    <b-dropdown-item>
                        <router-link :to="`/${$store.state.meta.lang}/discussion/create-new`">
                            <font-awesome-icon :icon='["fa", "plus-circle"]' /> &nbsp; {{ $t('gifts_create_discusssion') }}
                        </router-link>
                    </b-dropdown-item>
                    <b-dropdown-item>
                        <router-link :to="`/${$store.state.meta.lang}/discussion/bookmarked`">
                            <font-awesome-icon :icon='["fa", "bookmark"]' /> &nbsp; {{ $t('gifts_view_bookmarked') }}
                        </router-link>
                    </b-dropdown-item>
                    <b-dropdown-item>
                        <router-link :to="`/${$store.state.meta.lang}/discussion/created`">
                            <font-awesome-icon :icon='["fa", "pen-alt"]' /> &nbsp; {{ $t('gifts_view_created_discussions') }}
                        </router-link>
                    </b-dropdown-item>
                </b-dropdown>

                <b-dropdown
                    text="Help"
                    size="sm header_dropdown" 
                    v-if="false"
                >
                    <b-dropdown-item :href="`/${$store.state.meta.lang}/about/faq`">
                        <font-awesome-icon :icon='["fa", "question-circle"]' /> &nbsp; FAQ
                    </b-dropdown-item>
                    <b-dropdown-item :href="`/${$store.state.meta.lang}/about/guidelines`">
                        <font-awesome-icon :icon='["fa", "file-alt"]' /> &nbsp; {{ $t('gifts_guidelines') }}
                    </b-dropdown-item>
                </b-dropdown>
            </div>            
            <div class="d-sm-flex justify-content-xl-end justify-content-lg-end justify-content-sm-end" id="navbarNav">
                <ul class="navbar m-0 p-0">
                    <li v-if="$store.state.username" class="nav-item mr-4">
                        <router-link :to="`/${$store.state.meta.lang}/giveaway/created`">
                            <font-awesome-icon :icon='["fa", "gift"]' />
                        </router-link>
                    </li>
                    <li v-if="$store.state.username" class="nav-item mr-2">
                        <router-link :to="`/${$store.state.meta.lang}/giveaway/won`">
                            <font-awesome-icon :icon='["fa", "trophy"]' />
                            <span v-if="$store.state.meta.win" class="badge badge-danger navbar-badge">{{ $store.state.meta.win || 0}}</span>
                        </router-link>
                    </li>
                    <li v-if="$store.state.username" class="nav-item mr-4">                        
                        <!-- -- >> -->
                        <notification-button></notification-button>
                        <!-- << -- -->
                    </li>
                    <li v-if="$store.state.username" class="nav-item">                        
                        <search-box header-bar='true' v-if="!!$store.state.gameID && $store.state.meta.gamesDict[$store.state.gameID]"></search-box>
                        <button class="btn btn-secondary btn-sm rounded mr-4">{{ $t('gifts_account') }} ( {{$store.state.points }}P / {{ $t('gifts_level') }} {{ Math.floor($store.state.level) }} ) </button>
                    </li>
                    <li v-if="showMenu" class="nav-item logged" style="display: list-item;">                        
                        <router-link class="nav-link" :to='`/${$store.state.meta.lang}/user/${$store.state.username}`'>
                            <font-awesome-icon icon="user-astronaut"/>
                            <span class="fontSecondarySmall pl-2 cUserName menu-reduced text-uppercase">{{ $store.state.username.toUpperCase() }}</span>
                        </router-link>
                    </li>
                    <li v-if="showMenu" class="nav-item logged actLogOff" style="display: list-item;">
                        <loading-button
                            @click='logout'
                            :loading='loadingLogout'
                            class='nav-link'
                        >
                            <font-awesome-icon icon="sign-out-alt"/>
                        </loading-button>
                    </li>  
                    <li v-if=" $store.state.username.length <= 0" class="nav-item" style="display: list-item;">
                        <b-dropdown size="sm" variant="link" toggle-class="text-decoration-none" no-caret>
                            <template #button-content>
                                <font-awesome-icon  :icon="{ prefix: 'fas', iconName: 'sign-in-alt' }" />
                            </template>
                            <b-dropdown-item v-b-modal.loginModal>{{ $t('forum_login_txt') }}</b-dropdown-item>
                            <b-dropdown-item v-b-modal.registerModal>{{ $t('forum_register_txt') }}</b-dropdown-item>
                        </b-dropdown>
                    </li>                  
                </ul>
            </div>
            <!-- >> flags -->
            <div class="nav-item dropdown d-sm-block d-none">                
                <a  class="nav-link" 
                    href="javascript:void(0)" 
                    v-on:click="seen=!seen" 
                    id="navbarDropdown2" 
                    role="button" 
                    data-toggle="dropdown" 
                    aria-haspopup="true" 
                    aria-expanded="false">
                    <span :class="`flag setflag flag-${flag}`" v-bind:alt="flag"></span>
                </a>                
                <div v-if="seen" class="dropdown-menu dropdown-menu-right language-menu p-0 border-0 bg-transparent show mt-1" aria-labelledby="navbarDropdown2">                    
                    <span v-for="lang in this.$mMultiLangs" :key="lang" class="flag-bg">                        
                        <a v-if="$store.state.meta.lang != lang" 
                                    :href='"/"+lang+"/landing"' 
                                    class="h6 mb-0 d-flex flex-row px-3 py-2 border-right border-bottom border-green-lighter bgDarkTexture box-shadow"  
                                    :class="{'border-left' : ( lang=='ar' || lang=='ru' ) }"
                                    :title='lang.toUpperCase()' 
                                    :data-in='lang' 
                                    :data-out='lang'                                    
                                    >
                            <span :class='"flag flag-"+ getFlag(lang) +" mr-1"' :alt="lang"></span>{{ lang.toUpperCase() }}
                        </a>
                    </span>                    
                </div>
            </div> 
        </div>
        <div class='header__overlay' :class='{ "header__overlay--show": showMenu }' @click='toggleMenu'></div>
        <span class='header__menu_button' @click='toggleMenu'>
            <font-awesome-icon :icon='["fa", "bars"]' />
        </span>        
    </header> 
</template>
<script>
import AjaxErrorHandler from '../assets/js/errorHandler'
import LoadingButton from './LoadingButton';
import NotificationButton from './NotificationButton.vue';
import NotificationForm from './NotificationForm.vue';
import {apiDomain} from '../config';

export default {
    name: 'steamHeader',
    components: {
        LoadingButton,
        NotificationButton,
        NotificationForm
    },
    data () {
        return {
            selected: "wishlist",
            seen: false,
            wincheck: false,
            options: [
                {item: "wishlist", name:"wishlist"}
            ],
            loadingLogout: false,
            ajaxErrorHandler: AjaxErrorHandler(this.$store),
        }
    },
    computed: {                            
        showMenu: {
            get(){
                return !!this.$store.state.username;
            },
            set(val){
                return !!val;
            }
        },
        flag: function(){
            return  this.$store.state.meta.lang == 'cs' ? 'cz':
                    this.$store.state.meta.lang == 'el' ? 'gr':
                    this.$store.state.meta.lang == 'da' ? 'dk':
                    this.$store.state.meta.lang == 'uk' ? 'ua':
                    this.$store.state.meta.lang == 'bs' ? 'ba':
                    this.$store.state.meta.lang == 'sr' ? 'sk':
                    this.$store.state.meta.lang == 'vi' ? 'vn':
                    this.$store.state.meta.lang == 'ja' ? 'jp':
                    this.$store.state.meta.lang == 'ar' ? 'sa':
                    this.$store.state.meta.lang == 'sv' ? 'se':
                    this.$store.state.meta.lang == 'zh' ? 'cn':
                    this.$store.state.meta.lang == 'ko' ? 'kr': this.$store.state.meta.lang;
        }
    }, 
    methods: {
        getFlag( lang ){
            return  lang == 'cs' ? 'cz': lang == 'el' ? 'gr':
                    lang == 'vi' ? 'vn': lang == 'ja' ? 'jp':
                    lang == 'ar' ? 'sa': lang == 'ko' ? 'kr': 
                    lang == 'sv' ? 'se': lang == 'bs' ? 'ba': 
                    lang == 'da' ? 'dk': lang == 'uk' ? 'ua': 
                    lang == 'sr' ? 'sk': lang == 'zh' ? 'cn': 
                    lang;
        },
        toggleMenu () {
            this.showMenu = !this.showMenu
        },
        logout() {
            this.toggleMenu()
            this.loadingLogout = true

            this.axios.request({
                    method: 'post',
                    url: `${apiDomain}/api/v1/user/${this.$store.state.username}/logout`,
                    headers: {
                        'Authorization': `Bearer ${this.$cookies.get('authtoken')}`
                    }
                }
            ).then(res => {
                
                this.loadingLogout = false
                this.$store.commit('setProfile_photo_path', '')
                this.$store.commit('setUsername', '')
                this.$store.commit('setEmail', '')
                this.$store.commit('setPoints', 0)
                this.$store.commit('setLevel', 0)
                this.$store.commit('setAdmin', false)
                this.$store.commit('setWin', 0)
                this.$store.commit('setNmessages', '')
                
                this.$cookies.set('authtoken', '')
                this.$cookies.set('token', '')

                this.$router.push('/')
            }).catch(err => {
                this.loadingLogout = false
                this.ajaxErrorHandler(err)
            })
        },
    },
    watch: {
        $route () {
            this.showMenu = false
        }
    }
}
</script>
<style lang='scss' scoped>
html[data-useragent*='idclauncher'] header{margin-bottom: 3rem!important;}

/*
======================================================================================================================
Menu especi­fico del juego Top
======================================================================================================================
*/
.navbar li {
    list-style: none;
}

.navbar-brand {
    background-image: url("https://cdn.idcgames.net/img/default/logo-idc-dark.png");
    height: 40px;
    width: 40px;
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;    
}

.nav-custom-after .navbar-brand {
    background-image: url("https://cdn.idcgames.net/img/default/logo-idc-light.png");
    height: 40px;
}

.nav-custom {
    background-color: transparent;
    border-bottom: 1px solid #ffffff;
    transition: all 1s ease;
    padding: .3rem 1rem;
    height: 60px;
}

.nav-custom a {
    color: black;
}

.nav-custom-after {
    padding: 0rem 1rem;
    border-bottom: 1px solid #00ff7f;
    height: 47px;
}

.nav-custom-after a {
    color: #fff !important;
    transition: all 1s ease;
}

.nav-custom .dropdown-item, .nav-custom .dropdown-menu a{
    color: #fff;
}

.nav-custom .logged  a {
    color: #314954;
}

.nav-custom-after .logged a {
    color: #00ff7f!important;
}

@media (min-width: 576px) and (max-width: 767.98px){
    #navbarNav .fontSecondarySmall {
        font-size: 1.05rem;
    }
    #navbarNav ul {
        flex-wrap: nowrap;
    }
    #navbarNav .nav-link {
        padding: 0.5rem 0.55rem;
    }
    #navbarNav .menu-reduced {
        display: none;
    }
    #navbarNav{ padding-top: 0.1rem;}
}

.dropdown-menu-right {
    right: 0;
    left: auto;
}

/*Menu lateral*/
.featured {
    background: rgba(0,255,126,.2);
}

.btn-cta-small {
    display: none;
    white-space: nowrap;
    padding: 16px 30px;
    font-size: 1.5em;
    line-height: 0.1em;
    border: 5px solid black;
    left: 10%;
    cursor: pointer;
}

#navbarNav{
    margin-left: auto;
    margin-right: 10px;
}

@media (max-width: 767.98px) {
    .btn-cta-small {
        padding: 17px 15px;}
    #navbarNav{
        margin-left: unset!important; 
        margin-right: unset!important;}
 }

.nav-custom-after a.btn-cta-small {
    color: black!important;
}

.nav-custom-after a:hover.btn-cta-small {
    color: #00ff7f!important;
}

.flag {
    transform: scale(.5);
    margin: -20px;
}

@media (max-width: 575.98px) {
.flag {
    transform: scale(.4);
    margin: -20px;}
}

.language-menu.dropdown-menu.show {
    display: flex;
    flex-direction: row;
    width: 94vw;
    justify-content: flex-end;
    height: auto;
    flex-wrap: wrap;
    box-shadow: none;
}

.language-menu a {
    width: 97px;
    color: white;
}

/*Responsive basado en la altura de la pantalla y no en el ancho*/
@media (max-height: 740px) {
    .modal .display-4 {
        font-size: 3rem;
        font-weight: 700;
        line-height: 1.2;
    }

    .modal .h6 {
        font-size: 1rem;
    }

    .modal h4 {
        font-size: 1.5rem;
    }
    .loginModal .btn-cta.mt-xl-4, .registerModal .btn-cta.mt-xl-4 {
        margin-top: .25rem !important;
    }
    .modalMainContentContainer .mt-xl-5 {
        margin-top: .75rem !important;
    }

    .modalMainContentContainer .pt-xl-4  {
        padding-top: .5rem !important;
    }
}
/*
======================================================================================================================
Botones de logado/no logado
======================================================================================================================
*/
 .unlogged, .logged {
    display: none;
}

#searchForm .search-control {
    padding-left: 2.375rem;
}

#searchForm .form-control-feedback {
    position: absolute;
    z-index: 2;
    display: block;
    width: 2.375rem;
    height: 2.375rem;
    line-height: 2.375rem;
    text-align: center;
    pointer-events: none;
    color: #aaa;
}
</style>
<style>
.fontSecondarySmall {
    font-family: 'Bebas Neue';
    font-size: 1.3rem;
    font-weight: 500!important;
}
.modal-backdrop {
    position:fixed;
    top:0;
    right:0;
    bottom:0;
    left:0;
    z-index:1040;
    background-color: rgba(0 ,0, 0,0.7)!important;
}
.modal-backdrop.fade {
 opacity:0;
}
.modal-backdrop.show {
 opacity:.7;
}
.btn-sm, .btn-group-sm > .btn, .btn-group-sm > .btn{
    font-size: 1rem!important;
}
#navbarDropdown2{
    line-height: 1.2;
}
.header__group{
    height: 40px;
}
.navbar-badge {    
    position: absolute;
    left: 16px;
    top: -9px
}
.flag-bg{
    background: #14191e;
}
</style>